import type { Module } from '../../../../../api/module';
import type { UserMaterial } from '../../../../../api/user-material';
import { isLink, isFile, isLti } from '../../../../../api/user-material';
import AddLinkMaterialModal from '../../../../../shared-components/elementis/components/add-material-modal/add-link-material-modal';
import parseYoutubeURL from '../../../../../utils/parseYoutubeURL';
import { TOKEN_ACCESSOR } from '../../../../../utils/tokenAccessor';
import AddFileMaterialModal from '../../../../../shared-components/elementis/components/add-material-modal/add-file-material-modal';
import AddBookwidgetMaterialModal from '../../../../../shared-components/elementis/components/add-material-modal/add-bookwidget-material-modal';
import { buildAddBookwidgetUrl } from '../../../../../shared-components/elementis/util/buildBookWidgetsUrl';
import usePlatformName from '../../../../../hooks/usePlatformName';

interface Props {
  id: string;
  nodeId: string;
  module: Module;
  material: UserMaterial;
  onSubmitted: () => void;
}

export default function EditMaterialModal({ id, nodeId, module, material, onSubmitted }: Props) {
  const platformName = usePlatformName();

  if (isLink(material)) {
    const isYoutube = Boolean(parseYoutubeURL(material.href));

    return (
      <AddLinkMaterialModal
        id={id}
        tokenAccessor={TOKEN_ACCESSOR}
        moduleId={module.id}
        nodeId={nodeId}
        studioGroup={process.env.REACT_APP_P_STUDIO_GROUP}
        onSubmit={onSubmitted}
        isYouTube={isYoutube}
        material={material}
      />
    );
  }

  if (isFile(material)) {
    return (
      <AddFileMaterialModal
        id={id}
        tokenAccessor={TOKEN_ACCESSOR}
        moduleId={module.id}
        nodeId={nodeId}
        studioGroup={process.env.REACT_APP_P_STUDIO_GROUP}
        onSubmit={onSubmitted}
        material={material}
      />
    );
  }

  if (isLti(material)) {
    return (
      <AddBookwidgetMaterialModal
        id={id}
        tokenAccessor={TOKEN_ACCESSOR}
        moduleId={module.id}
        nodeId={nodeId}
        studioGroup={process.env.REACT_APP_P_STUDIO_GROUP}
        onSubmit={onSubmitted}
        material={material}
        bookwidgetUrl={buildAddBookwidgetUrl({
          ltipsUrl: process.env.REACT_APP_LTI_AUTH_URL,
          studioLanguage: process.env.REACT_APP_P_STUDIO_GROUP,
          module,
          platformName,
        })}
      />
    );
  }

  throw new Error('Editing an unsupported material type');
}
